import React from 'react';

import { FIELD_PATHS, FREQUENCY_OPTIONS } from '@funnels/constants';
import { useAnalytics } from '@funnels/providers';

import { DropdownField } from '../../Fields';
import { EditableViewProps } from '../types';

interface RentalIncomeFrequencyEditableViewProps extends EditableViewProps {
  label?: string;
  incomeIndex: number;
}
export const RentalIncomeFrequencyEditableView = (props: RentalIncomeFrequencyEditableViewProps) => {
  const { tracking } = useAnalytics();
  const { label = 'Frequency', incomeIndex, ...rest } = props;
  const handleTracking = (selectedValues: string[]) => {
    const selectedValue = selectedValues[0];
    if (!selectedValue) return;
    const selection =
      FREQUENCY_OPTIONS.find((option) => {
        return option.value === selectedValue;
      })?.label || '';
    tracking?.dropdown({ title: label, selection, position: 'Property - Rental Income' });
  };

  return (
    <DropdownField
      {...rest}
      label={label}
      name={FIELD_PATHS.INCOME_FREQUENCY(incomeIndex)}
      options={FREQUENCY_OPTIONS}
      onChange={handleTracking}
    />
  );
};
